var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgM4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1399_903)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1399_903",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.8147e-06H32V32H0V3.8147e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1399_903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.28802 8.30882C6.30934 8.8527 6.90227 9.32395 7.41915 10.1637C8.65109 12.162 9.78034 12.1974 11.1008 13.0213L15.2002 15.5776C15.9206 16.0259 16.5188 16.2172 16.9171 15.4678C17.3154 14.7184 16.9472 13.1612 16.0993 12.2825L13.8302 9.92626C13.308 9.31151 13.662 8.92713 14.5276 8.78182C16.8463 8.39382 17.3826 9.40013 18.4128 11.1699M22.8007 12.4455L20.3245 8.07676C18.9296 5.4867 16.402 5.60357 13.786 5.29182C10.8955 4.94632 10.6742 4.58851 8.01565 3.17476",
    stroke: "#A3E9E6",
    strokeWidth: 1.261,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.65767 8.25038L3.67549 9.32575C4.13567 9.57019 4.71099 9.39306 4.95524 8.93419L8.05986 3.08975C8.30411 2.63088 8.12892 2.05338 7.66867 1.81063L5.65086 0.735313C5.19067 0.490814 4.61536 0.666189 4.37111 1.12681L1.26649 6.97131C1.02224 7.43013 1.19749 8.00588 1.65767 8.25038Z",
    stroke: "#A3E9E6",
    strokeWidth: 1.261,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.09009 18.3236H30.8438V30.0303C30.8438 30.769 30.2385 31.3749 29.5003 31.3749H10.4335C9.69546 31.3749 9.09009 30.769 9.09009 30.0303V18.3236Z",
    stroke: "#A3E9E6",
    strokeWidth: 1.261,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9455 18.3236C16.1631 17.661 15.6693 16.7434 15.5223 15.7637M16.356 12.589C17.5756 11.0211 19.7775 10.5091 21.59 11.4729C23.6167 12.5535 24.3867 15.0727 23.3087 17.103C23.0538 17.583 22.7175 17.9923 22.3282 18.3236",
    stroke: "#A3E9E6",
    strokeWidth: 1.261,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7032 22.028H30.8438M9.09009 22.028H13.0957",
    stroke: "#A3E9E6",
    strokeWidth: 1.261,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 28.2942H25.9337V25.1071H14.0001V28.2942Z",
    stroke: "#A3E9E6",
    strokeWidth: 1.261,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9033 22.028H15.8994",
    stroke: "#A3E9E6",
    strokeWidth: 1.261,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1399_903"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgM4);
export default __webpack_public_path__ + "static/media/m4.b87369b61ed014311e2a41988db04e76.svg";
export { ForwardRef as ReactComponent };